var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import apiClient from "./apiClient";
var LocalizedClient = (function (_super) {
    __extends(LocalizedClient, _super);
    function LocalizedClient() {
        var _a, _b, _c;
        var _this = _super.apply(this, arguments) || this;
        _this.currencyCode = ((_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode) || 'USD';
        _this.countryCode = ((_b = window.reactSystemData) === null || _b === void 0 ? void 0 : _b.countryCode) || '';
        _this.locale = ((_c = window.reactSystemData) === null || _c === void 0 ? void 0 : _c.locale) || '';
        return _this;
    }
    LocalizedClient.prototype.buildLocalizedParams = function () {
        var params = [
            "currency",
            this.currencyCode
        ];
        if (this.countryCode) {
            params.push("country");
            params.push(this.countryCode);
        }
        if (this.locale) {
            params.push("locale");
            params.push(this.locale.split('_').join('-'));
        }
        return params;
    };
    return LocalizedClient;
}(apiClient));
export default LocalizedClient;
//# sourceMappingURL=localizedClient.js.map